import { MERCHANT } from "constants/action-types";
import { Observable } from "rxjs";
import { ActionsObservable } from "redux-observable";
import { ajax } from "lib/observable";
import siteConfig from "site-config";
import { formatMessage } from "lib/globalize-util";
import { add as snackbarAdd } from "actions/snackbars";
import {
    createMerchantDefaultItemComplete,
    CreateMerchantDefaultItemRequestAction,
    getMerchantDefaultItemComplete,
    GetMerchantDefaultItemRequestAction,
    updateMerchantDefaultItemComplete,
    UpdateMerchantDefaultItemRequestAction,
} from "actions/merchant";

export const getMerchantDefaultItemEpic = (action$: ActionsObservable<GetMerchantDefaultItemRequestAction>) =>
    action$
        .ofType(MERCHANT.DEFAULT_ITEM.GET.REQUEST)
        .map(({ payload }) => payload)
        .switchMap(({ merchantId }) => {
            return ajax(`${siteConfig.goAPI}/v1/collections/merchants/${merchantId}/default_item`)
                .flatMap(({ response, status }) => {
                    if (status !== 200) {
                        throw new Error(response.message || formatMessage("Unknown fetch error"));
                    }
                    return [getMerchantDefaultItemComplete(response.default_item)];
                })
                .catch((error) => Observable.merge(Observable.of(getMerchantDefaultItemComplete(error))));
        });

export const createMerchantDefaultItemEpic = (action$: ActionsObservable<CreateMerchantDefaultItemRequestAction>) =>
    action$
        .ofType(MERCHANT.DEFAULT_ITEM.CREATE.REQUEST)
        .map(({ payload }) => payload)
        .switchMap(({ merchantId, defaultItem }) => {
            return ajax({
                method: "POST",
                url: `${siteConfig.goAPI}/v1/collections/merchants/${merchantId}/default_item`,
                body: {
                    default_item: defaultItem,
                },
            })
                .flatMap(({ response }) => {
                    return [
                        createMerchantDefaultItemComplete(response.default_item),
                        snackbarAdd({ message: formatMessage("Merchant default item created") }),
                    ];
                })
                .catch((error) =>
                    Observable.merge(
                        Observable.of(createMerchantDefaultItemComplete(error)),
                        Observable.of(snackbarAdd({ message: error.message || formatMessage("Error saving") }))
                    )
                );
        });

export const updateMerchantDefaultItemEpic = (action$: ActionsObservable<UpdateMerchantDefaultItemRequestAction>) =>
    action$
        .ofType(MERCHANT.DEFAULT_ITEM.UPDATE.REQUEST)
        .map(({ payload }) => payload)
        .switchMap(({ merchantId, defaultItem }) => {
            return ajax({
                method: "PUT",
                url: `${siteConfig.goAPI}/v1/collections/merchants/${merchantId}/default_item`,
                body: {
                    default_item: defaultItem,
                },
            })
                .flatMap(({ response }) => {
                    return [
                        updateMerchantDefaultItemComplete(response.default_item),
                        snackbarAdd({ message: formatMessage("Merchant default item updated") }),
                    ];
                })
                .catch((error) =>
                    Observable.merge(
                        Observable.of(updateMerchantDefaultItemComplete(error)),
                        Observable.of(snackbarAdd({ message: error.message || formatMessage("Error saving") }))
                    )
                );
        });
